<template>
  <div
    v-if="!redemptionUltimateFailureReason"
    class="w-full flex-1-0-auto"
  >
    <div class="container">
      <form class="w-full max-w-2xl m-0" @submit.prevent="onSubmit">
        <div v-if="errors.length" class="w-full p-4 mt-2 mb-4 bg-sw_red_error-background">
          <p class="pb-2 text-sm font-bold leading-none xl:text-lg">
            {{ $t(`errors.type.${firstErrorKey}.title`, brandInfo) }}
          </p>
          <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${firstErrorKey}.description`, brandInfo)" />
        </div>

        <TextInput
          v-model.trim="voucherCode"
          :placeholder="$t('components.form.flightvoucherCode.placeholder')"
          :label="$t('components.form.flightvoucherCode.label')"
          :error="$v.voucherCode.$error ? $t('components.form.error.voucherCode') : undefined"
          extra-class="mb-5"
        />

        <div class="flex pt-2 xl:pt-8">
          <Button :loading="loading" class="w-full xl:ml-auto xl:w-auto">
            {{ $t('pages.redemption.submitButton') }}
          </Button>
        </div>
      </form>
    </div>
  </div>
  <Loading v-else class="container pt-6 border-t xl:pt-8 border-sw_gray-300">
    <p class="max-w-sm pt-6 mx-auto text-center xl:pt-12">
      {{ $t(`errors.type.${errors[0]}.title`) }}
      <br>
      {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
    </p>
    <p class="max-w-sm pt-2 mx-auto text-center">
      {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
    </p>
  </Loading>
</template>

<script lang="ts">
import Form from '~psp-pages/base/home/form.ts'

import Button from '~brand-components/swiss/button/button.vue'
import TextInput from '~brand-components/swiss/shared/text-input.vue'
import Loading from '~brand-components/swiss/loading/loading.vue'

export default Form.extend({
  components: {
    Button,
    TextInput,
    Loading,
  },
})
</script>
